import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal, ModalBody } from "reactstrap";
import ataEncaminhamentosService from "services/AtaEncaminhamentosService";
import { SignOut, Trash } from "@phosphor-icons/react";

const ExcludeModal = ({ show, onCloseClick, data }) => {
	const [excludeAtaId, setExcludeAta] = useState(0);
	const [exclude, setExclude] = useState(0);

	const onDeleteClick = async () => {
		try {
			await ataEncaminhamentosService.del(excludeAtaId);
		} catch (error) {
			console.log(error);
		}
		onCloseClick();
	};

	const clickExclude = () => {
		setExclude(exclude + 1);
		if (exclude === 0) {
			onDeleteClick();
		}
	};

	useEffect(() => {
		setExcludeAta(data?.id);
		setExclude(0);
	}, [data]);

	return (
		<Modal
			size="sm"
			isOpen={show}
			toggle={onCloseClick}
			centered={true}
			style={{ minWidth: 700 }}
			zIndex={1500}
		>
			<div className="modal-content">
				<ModalBody className="px-4 py-5 text-center">
					<p className="text-muted font-size-16">
						Tem certeza de que deseja excluir o encaminhamento?
					</p>
					<p className="text-muted font-size-16 fw-bold flex">
						{data?.description}
					</p>

					<div className="hstack gap-2 justify-content-center mb-0">
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={clickExclude}
						>
							<Trash size={16} /> Excluir
						</Button>
						<Button
							type="button"
							style={{
								background: "none",
								padding: 10,
								cursor: "pointer",
								color: "black",
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								gap: 2,
							}}
							onClick={onCloseClick}
						>
							<SignOut size={16} /> Fechar
						</Button>
					</div>
				</ModalBody>
			</div>
		</Modal>
	);
};

ExcludeModal.propTypes = {
	show: PropTypes.bool,
	onCloseClick: PropTypes.func,
	data: PropTypes.any,
};

export default ExcludeModal;
